<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 14:50:57
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-21 19:01:54
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/scx/component-scx.vue
 * @Description: 生产线
-->
<template>
  <div class="scx">
    <div class="item" v-for="(item, index) in data" :key="index">
      <el-row style="margin-bottom: 23px">
        <el-col :span="18">
          <span class="title">{{ item.scmc }}</span>
        </el-col>
        <el-col :span="6">
          <section
            :class="[item.sczt === '生产中' ? 'status-scz' : 'status-whz']"
          ></section>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <section class="icon-01">
            <span class="value">{{ item.scsl }}</span>
            <span class="unit">{{ item.scdw }}</span>
          </section>
        </el-col>
        <el-col :span="8">
          <section class="icon-02">
            <span class="value">{{ item.yxsc }}</span>
            <span class="unit">小时</span>
          </section>
        </el-col>
        <el-col :span="8">
          <section class="icon-03">
            <chart-liquidfill class="content" :data="item.scjd" />
            <section class="title"></section>
          </section>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
.scx {
  .item {
    margin-bottom: 44px;
    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .status-scz {
      width: 64px;
      height: 23px;
      background: url("/public/image/production-management/icon/生产中@2x.png");
    }
    .status-whz {
      width: 64px;
      height: 23px;
      background: url("/public/image/production-management/icon/维护中@2x.png");
    }
    .icon-01 {
      width: 78px;
      height: 115px;
      background: url("/public/image/production-management/icon/生产数量@2x.png");
      position: relative;
      .value {
        position: absolute;
        top: 18px;
        width: 100%;
        text-align: center;
        font-size: 22px;
        font-family: Bahnschrift;
        font-weight: 400;
        color: #6df9ff;
      }
      .unit {
        position: absolute;
        top: 42px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a8e4e5;
      }
    }
    .icon-02 {
      width: 78px;
      height: 115px;
      background: url("/public/image/production-management/icon/运行时长@2x.png");
      position: relative;
      .value {
        position: absolute;
        top: 18px;
        width: 100%;
        text-align: center;
        font-size: 22px;
        font-family: Bahnschrift;
        font-weight: 400;
        color: #10f5b1;
      }
      .unit {
        position: absolute;
        top: 42px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a8e4e5;
      }
    }
    .icon-03 {
      width: 78px;
      height: 115px;
      position: relative;
      .content {
        position: absolute;
        display: block;
        top: -10px;
        left: -25px;
        width: 78px;
        height: 78px;
      }
      .title {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 74px;
        height: 29px;
        background: url("/public/image/production-management/icon/生产进度@2x.png");
      }
    }
  }
}
</style>
